import { render, staticRenderFns } from "./itemsFilterTable.vue?vue&type=template&id=cd5d65f2&"
import script from "./itemsFilterTable.vue?vue&type=script&lang=js&"
export * from "./itemsFilterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports